import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import PieChartIcon from "@material-ui/icons/PieChart";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { Grid, Box, Button, Typography } from "@material-ui/core";
import StatBoxSlim from "components/Stats/StatBoxSlim";
import PictreeReportPieDrawer from "components/Charts/PictreeReportPieDrawer";
import clsx from "clsx";
import { getHomePictreeReportStats } from "actions";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    content: {
      flexGrow: 1,
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginRight: 0,
    },
    contentShift: {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 500, // Drawer width
    },
    lblPercent: {
      marginTop: 32,
      flexGrow: 1,
      textAlign: "right",
      fontSize: 13,
    },
    tooltip: {
      position: "absolute",
      top: "8px",
      left: "50%",
      transform: "translateX(-50%)",
      padding: "5px 10px",
      borderRadius: "4px",
      fontSize: "14px",
      whiteSpace: "nowrap",
    },
  })
);

const ReportStats = ({
  dateRangePicTree,
  dateRagngePicTreeNtt,
  dateRagngePicTreeNttFt,
  dateRagngePicTreeHokuden,
  getHomePictreeReportStats,
  homeDataReportStats,
  company,
}) => {
  const classes = useStyles();
  const [initialDataCall, setInitialDataCall] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);

  useEffect(() => {
    if (
      dateRangePicTree[0] !== null &&
      dateRangePicTree[1] !== null &&
      company === "tepco" &&
      initialDataCall
    ) {
      getHomePictreeReportStats("tepco");
      setInitialDataCall(false);
    }
  }, [dateRangePicTree]);

  useEffect(() => {
    if (
      dateRagngePicTreeNtt[0] !== null &&
      dateRagngePicTreeNtt[1] !== null &&
      company === "ntt" &&
      initialDataCall
    ) {
      getHomePictreeReportStats("ntt");
      setInitialDataCall(false);
    }
  }, [dateRagngePicTreeNtt]);

  useEffect(() => {
    if (
      dateRagngePicTreeNttFt[0] !== null &&
      dateRagngePicTreeNttFt[1] !== null &&
      company === "ntt-ft" &&
      initialDataCall
    ) {
      getHomePictreeReportStats("ntt-ft");
      setInitialDataCall(false);
    }
  }, [dateRagngePicTreeNttFt]);

  useEffect(() => {
    if (
      dateRagngePicTreeHokuden[0] !== null &&
      dateRagngePicTreeHokuden[1] !== null &&
      company === "hepco" &&
      initialDataCall
    ) {
      getHomePictreeReportStats("hepco");
      setInitialDataCall(false);
    }
  }, [dateRagngePicTreeHokuden]);

  return (
    <div className={classes.root}>
    <main
      className={clsx(classes.content, {
        [classes.contentShift]: drawerOpen,
      })}
    >
    <div style={{ marginBottom: 16 }}>
      <Tooltip title={drawerOpen ? "グラフを閉じる" : "グラフで表示"}>
        <IconButton
          onClick={drawerOpen ? handleDrawerClose : handleDrawerOpen}
          style={{
            color: drawerOpen ? "#1976d2" : "#9e9e9e", // blue or gray
            border: "1px solid",
            borderColor: drawerOpen ? "#1976d2" : "#ccc",
            borderRadius: 4,
            padding: 6,
          }}
        >
          <PieChartIcon />
        </IconButton>
      </Tooltip>
    </div>

    <Grid container spacing={1}>
      <Grid item sm={12}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={2}>
            <StatBoxSlim
              title="報告件数"
              value={
                homeDataReportStats?.totalCount !== undefined
                  ? homeDataReportStats.totalCount
                  : "-"
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <StatBoxSlim
              title="報告者数"
              value={
                homeDataReportStats?.totalPlayerCount !== undefined
                  ? homeDataReportStats.totalPlayerCount
                  : "-"
              }
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item sm={12}>
        <Grid container spacing={1}>
          {homeDataReportStats?.reportStats?.map((stat, index) => {
            const total = homeDataReportStats?.totalCount ?? 0;
            const percent =
              total > 0
                ? `${((stat.total_count / total) * 100).toFixed(2)}%`
                : "-";

              return (
                <Grid item xs={12} sm={6} md={2} key={index}>
                  <StatBoxSlim
                    title={stat.tag_label}
                    value={stat.total_count ?? "-"}
                    tip={stat.name}
                    valueExtra={`全体比率: ${percent}`
                    }
                  />
                </Grid>
              );
          })}
        </Grid>
      </Grid>
    </Grid>
    </main>
      <PictreeReportPieDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        data={homeDataReportStats?.reportStats ?? []}
      />
    </div>
  );
};

ReportStats.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  dateRangePicTree: state.page.dateRangePicTree,
  dateRagngePicTreeNtt: state.page.dateRangePicTreeNtt,
  dateRagngePicTreeNttFt: state.page.dateRangePicTreeNttFt,
  dateRagngePicTreeHokuden: state.page.dateRangePicTreeHokuden,
  homeDataReportStats: state.pictree.homeDataReportStats,
});

const mapDispatchToProps = (dispatch) => ({
  getHomePictreeReportStats: (param) => dispatch(getHomePictreeReportStats(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(ReportStats));
